<template>
    <div class="custom-page">
        <component v-if="show_not_found" :is="`not-found`"></component>
        <default v-else>
            <template #content>
                <div v-if="city_images.length" class="content no-select">
                    <div class="col-xs-12 col-sm-8">
                        <div class="content" v-html="content"></div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="city-image" v-for="(val, key) in city_images" :key="key">
                            <img class="img-responsive" :src="val">
                        </div>
                    </div>
                </div>
                <div v-else>
                  <div class="page-con-header custom-page-pch">
                    <div v-if="!showDesktop" class="mobile-back-link">
                      <a href="#" class="page-header-3 back-link mobile-title" @click.prevent.stop="handleBackClick">
                        <svg height="36" width="36" class="t-icon chevron-left icon-svg"></svg>
                      </a>
                      <h3 class="color-pink">{{ title | translate }}</h3>
                    </div>
                    <template v-else>
                      <a href="#" class="page-header-3 back-link mobile-title" @click.prevent.stop="handleBackClick">
                        <svg height="36" width="36" class="t-icon chevron-left icon-svg"></svg>
                      </a>
                      <h3 class="color-pink pub-headers">{{ title | translate }}</h3>
                    </template>
                  </div>
                  <div
                   :class="[{ 'reviews-page': $route.fullPath === '/reviews' }, 'row content  dynamic-content no-select']"
                    v-html="content"
                  />
                </div>
            </template>
        </default>
    </div>
</template>

<script>
  import CustomPage from '@views/public/pages/CustomPage/custom_page'
	import NotFound from '@theme-views/public/pages/NotFound'
  import Default from '@theme-views/public/layouts/Default'
  import {handleBackBtn} from '@/helpers'

  export default {
    mixins: [CustomPage],
    data() {
      return {
        cdn_url: window.APP_CONFIG.CDN_URL
      }
    },
    components: {
        Default,
        NotFound
    },
    methods: {
      handleBackClick() {
        handleBackBtn(this.$router, this.routeFrom, this.backFallbackRoute)
      },
    },
    computed: {
      showDesktop() {
            return this.$root.$children[0].width > 1199
        },
    },
    mounted() {
      console.log(this.content)
    }
  }
</script>

<style lang="scss" src="./custom-page.scss"></style>
